import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback } from 'react';
import { propFunc, propBool, propStr, } from '../../../../helpers/custom-prop-types';
import SubmitButton from '../../../Ui/Button/SubmitButton';
import ProfessionalUnitCompanySubscribeButtonInner from './ProfessionalUnitCompanySubscribeButtonInner';
const ProfessionalUnitCompanySubscribeButton = (props) => {
    const { checked, className, loading, onChange } = props;
    const wrapOnChange = useCallback((e) => {
        const { value } = e.currentTarget;
        const currentChecked = !!parseInt(value, 10);
        onChange(currentChecked);
    }, [onChange]);
    return (_jsx(SubmitButton, { buttonType: 'button', className: clsx('unit_subscribe_button', className), isDisabled: loading, isLoading: loading, onClick: wrapOnChange, text: _jsx(ProfessionalUnitCompanySubscribeButtonInner, { checked: checked }), value: checked ? '1' : '0' }));
};
ProfessionalUnitCompanySubscribeButton.propTypes = {
    checked: propBool().isRequired,
    className: propStr(),
    loading: propBool(),
    onChange: propFunc(),
};
ProfessionalUnitCompanySubscribeButton.defaultProps = {
    className: '',
    loading: false,
    onChange: undefined,
};
export default ProfessionalUnitCompanySubscribeButton;
